<ion-row class="p-10 headerBreadcrumb"> 
      <ion-col size>
        <!-- <div class="formLabelSemiBoldfs16 mb-5">{{ data.operation === 'Add' ? 'Add' : 'Edit' }} Reimbursement</div> -->
        <div class="formLabelSemiBoldfs16">Offer Letter Preview </div>
      </ion-col>
      <ion-col size="auto">
        <img [mat-dialog-close] class="cp" src="././assets/icon/close_icon.png">
      </ion-col>
</ion-row>

<div class="modal-body ">
  
  <!-- <ion-row>
    <ion-col size="12">
      <div class="horizontal-row"></div>
    </ion-col>
  </ion-row> -->

  <!-- <ion-row>
    <ion-col size="12"> -->
      <div class="selectDownload">
        <div class="select-comgination-checkbox">
          <section class="mat-checkbox-style">
            <mat-checkbox
              [(ngModel)]="selectAllChecked"
              (change)="toggleSelectAll()"
              >Select All</mat-checkbox
            >
          </section>
        </div>
        <div *ngIf="isShowDownloadBtn">
          <button
            class="materialBtnIcon black_color fs-14 fs_12ForMobile font_semibold mr-15"
            (click)="downloadSelected()"
          >
            <span class="material-icons">download</span>
          </button>
        </div>
      </div>
    <!-- </ion-col>
  </ion-row> -->

  <!-- <ion-row>
    <ion-col
      size="12"
      class="d-flex"
      style="gap: 16px"
    > -->
  
      <div class="card-container">
        <div
          class="cardBox"
          *ngFor="let data of offerLetterData; let id = index"
        >
          <div>
            <section class="mat-checkbox-style fs-16 fs_14ForMobile">
              <mat-checkbox style="font-size: 16px;"
                [(ngModel)]="data.isChecked"
                (change)="onCheckboxChange($event,data)"
                >{{ data.firstName }}  {{data.lastName}}</mat-checkbox
              >
            </section>
          </div>
          <div class="fs-14 fs_12ForMobile" style="margin-left: 42px;white-space: pre-line;">
            
            <span>{{ formatDate(data.sendDate) }}</span>

          </div>
          <div class="cartContent mt-10">
            <span class="material-icons fs-14 fs_12ForMobile text_blue">visibility</span
            ><span
              class="fs-12 text_blue cp"
              (click)="onClickPreviewLetter(data.firstName , data.candidateId,data.fileName)"
            >
              Preview</span
            >
           
          </div>
        </div>
      </div>
    <!-- </ion-col>
  </ion-row> -->
</div>
